export default "__VITE_ASSET__i1B9pfm6__"